import { createRoutine } from 'redux-routines';
import {
  INIT, LOADING, SUCCESS, FAILURE,
} from '@constants/requestPhase';
import * as api from './api';

const resetPhasesAction = 'RESET_EVENTS_PHASES';
// < ----- ACTIONS ----- > //
const getAccessRequestsListRoutine = createRoutine(
  'GER_ACCESS_REQUESTS_LIST',
);

const requestAccessRoutine = createRoutine(
  'REQUEST_ACCESS',
);

const editAccessRequestRoutine = createRoutine(
  'EDIT_ACCESS_REQUEST',
);

const cancelAccessRequestRoutine = createRoutine(
  'CANCEL_ACCESS_REQUEST',
);

const resetStoreToInitialStateAction = 'RESET_STORE';

// < ----- ACTION CREATORS ----- > //
export const editAccessRequest = (id, data) => async dispatch => {
  try {
    dispatch(editAccessRequestRoutine.request());

    const response = await api.editAccessRequest(id, data);

    return dispatch(editAccessRequestRoutine.success(response.data));
  } catch (error) {
    return dispatch(editAccessRequestRoutine.failure(error.response));
  }
};

export const cancelRequestAccess = id => async dispatch => {
  try {
    dispatch(cancelAccessRequestRoutine.request());

    await api.cancelAccessRequest(id);

    return dispatch(cancelAccessRequestRoutine.success(id));
  } catch (error) {
    return dispatch(cancelAccessRequestRoutine.failure(error.response));
  }
};

export const getAccessRequestsList = data => async dispatch => {
  try {
    dispatch(getAccessRequestsListRoutine.request());

    const response = await api.getAccessRequestsList(data);

    return dispatch(getAccessRequestsListRoutine.success(response.data));
  } catch (error) {
    return dispatch(getAccessRequestsListRoutine.failure(error.response));
  }
};

export const requestAccess = data => async dispatch => {
  try {
    dispatch(requestAccessRoutine.request());

    const response = await api.requestAccess(data);

    return dispatch(requestAccessRoutine.success(response.data));
  } catch (error) {
    return dispatch(requestAccessRoutine.failure(error.response));
  }
};

export const resetStore = () => ({
  type: resetStoreToInitialStateAction,
});

export const resetPhases = () => ({
  type: resetPhasesAction,
});

// < ----- STATE ----- > //
export const roomStorePersistWhitelist = [];

const initialState = {
  requests: [],

  getAccessRequestsListPhase: INIT,
  getAccessRequestsListError: null,

  requestAccessPhase: INIT,
  requestAccessError: null,

  editAccessRequestPhase: INIT,
  editAccessRequestError: null,

  cancelAccessRequestPhase: INIT,
  cancelAccessRequestError: null,
};

// < ----- STORE REDUCER ----- > //
const store = (state = initialState, { type, payload }) => {
  switch (type) {
    // RESET STORE TO INITIAL STATE
    case resetStoreToInitialStateAction:
      return initialState;

    // RESET PHASES
    case resetPhasesAction:
      return {
        ...state,

        getAccessRequestsListPhase: INIT,
        getAccessRequestsListError: null,

        cancelAccessRequestPhase: INIT,
        cancelAccessRequestError: null,

        editAccessRequestPhase: INIT,
        editAccessRequestError: null,

        requestAccessPhase: INIT,
        requestAccessError: null,
      };
    // GET LIST
    case getAccessRequestsListRoutine.REQUEST:
      return {
        ...state,
        getAccessRequestsListPhase: LOADING,
      };
    case getAccessRequestsListRoutine.SUCCESS:
      return {
        ...state,
        getAccessRequestsListPhase: SUCCESS,
        requests: payload.data.map(request => ({
          firstDate: request.from,
          secondDate: request.to,
          time: request.arriveAt,
          id: request.id,
          location: {
            id: request.location.id,
            image: request.location.image,
            title: request.location.title,
          },
        })),
      };
    case getAccessRequestsListRoutine.FAILURE:
      return {
        ...state,
        getAccessRequestsListPhase: FAILURE,
        getAccessRequestsListError: payload,
      };
    // EDIT REQUEST
    case editAccessRequestRoutine.REQUEST:
      return {
        ...state,
        editAccessRequestPhase: LOADING,
      };
    case editAccessRequestRoutine.SUCCESS:
      return {
        ...state,
        editAccessRequestPhase: SUCCESS,
        requests: state.requests.map(
          request => {
            if(request.id === payload.data.id) {
              return {
                firstDate: payload.data.from,
                secondDate: payload.data.to,
                time: payload.data.arriveAt,
                id: payload.data.id,
                location: {
                  id: payload.data.location.id,
                  image: payload.data.location.image,
                  title: payload.data.location.title,
                }};
            }
            return request;
          },
        ),
      };
    case editAccessRequestRoutine.FAILURE:
      return {
        ...state,
        editAccessRequestPhase: FAILURE,
        editAccessRequestError: payload,
      };
      // CANCEL REQUEST
    case cancelAccessRequestRoutine.REQUEST:
      return {
        ...state,
        cancelAccessRequestPhase: LOADING,
      };
    case cancelAccessRequestRoutine.SUCCESS:
      return {
        ...state,
        requests: state.requests.filter(
          request => request.id !== payload,
        ),
        cancelAccessRequestPhase: SUCCESS,
      };
    case cancelAccessRequestRoutine.FAILURE:
      return {
        ...state,
        cancelAccessRequestPhase: FAILURE,
        cancelAccessRequestError: payload,
      };
    // REQUEST ACCESS
    case requestAccessRoutine.REQUEST:
      return {
        ...state,
        requestAccessPhase: LOADING,
      };
    case requestAccessRoutine.SUCCESS:
      return {
        ...state,
        requestAccessPhase: SUCCESS,
        requests: [{
          firstDate: payload.data.from,
          secondDate: payload.data.to,
          time: payload.data.arriveAt,
          id: payload.data.id,
          location: {
            id: payload.data.location.id,
            image: payload.data.location.image,
            title: payload.data.location.title,
          }}, ...state.requests],
      };
    case requestAccessRoutine.FAILURE:
      return {
        ...state,
        requestAccessPhase: FAILURE,
        requestAccessError: payload,
      };
    default:
      return state;
  }
};

export default store;
